module.exports = __webpack_public_path__ + "img/part6-icon4.39ba97e1.png";